import { 
    MessageResponseDto, 
    GetRewardTypeDto, 
    CreateRewardTypeDto, 
    EditRewardTypeDto,
    UtilRewardTypeControllerGet200Response,
    UtilityRewardTypeApiFp,
    DeleteRewardTypeDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseRewardTypeModel = UtilRewardTypeControllerGet200Response;
export type GetRewardTypeModel = GetRewardTypeDto;
export type MutateResponseRewardTypeModel = MessageResponseDto;
export type CreateRewardTypeModel = CreateRewardTypeDto;
export type UpdateRewardTypeModel = EditRewardTypeDto;
export type DeleteRewardTypeModel = DeleteRewardTypeDto;

export const apiRewardTypeFp =  UtilityRewardTypeApiFp(apiConfig);
export const getRewardTypeController = apiRewardTypeFp.utilRewardTypeControllerGet;
export const createRewardTypeController = apiRewardTypeFp.utilRewardTypeControllerCreate;
export const updateRewardTypeController = apiRewardTypeFp.utilRewardTypeControllerEdit;
export const deleteRewardTypeController = apiRewardTypeFp.utilRewardTypeControllerDelete;

export const QueryKeyRewardType = QueryKey.RewardType;